/*( document ).ready(function() {
setInterval(function() {
jQuery.getJSON('/cart.js', function(cart) {
let cartData = cart.item_count;
$(".cart-count-bubble span").text(cartData);
   $('#CartDrawer').load(location.href + " #CartDrawer");
});
}, 400);

$(".product-form__buttons .product-form__submit ").click(function(){
setTimeout(function () {
$('#CartDrawer').load(location.href + " #CartDrawer");
 $("a#cart-icon-bubble span.visually-hidden").trigger("click");
}, 400);
})
  })*/

// $(window).on('load', function(){
//     $('#gallery')[0].slick.setPosition()
// });


whenSlickReady(function ($) {
  $('#gallery').slick({
   dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 4000,
    slidesToShow: 4,
    slidesToScroll: 4,
  // dots: false,
  //   arrows: false,
  //   desToShow: 6,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 0,
  //   speed: 5000,
  //   pauseOnHover: false,
  //   cssEase: 'linear',
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1 
        }
      }
    ]
  });
});     


whenSlickReady(function ($) {
  $('.brand-slider1').slick({
    
  
        speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1 
        }
      }
    ]
  });
}); 
whenSlickReady(function ($) {
  $('.brand-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2000,
    slidesToShow: 5,
    slidesToScroll: 1,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1 
        }
      }
    ]
  });
});

whenSlickReady(function ($) {
  $('.text-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1 
        }
      }
    ]
  });
});


whenSlickReady(function ($) {
  $('.prod-detail-slider, .testimonials-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000, 
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'ease-in-out'
  });
});



var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// fade in grid items  ==================================

  // $(document).on("scroll", function () {
  //   var pageTop = $(document).scrollTop()
  //   var pageBottom = pageTop + $(window).height()
  //   var tags = $(".fadein")

  //   for (var i = 0; i < tags.length; i++) {
  //     var tag = tags[i]

  //     if ($(tag).offset().top < pageBottom) {
  //       $(tag).addClass("visible")
  //     } else {
  //       $(tag).removeClass("visible")
  //     }
  //   }
  // })



	$.fn.jQuerySimpleCounter = function( options ) {
	    var settings = $.extend({
	        start:  0,
	        end:    100,
	        easing: 'swing',
	        duration: 400,
	        complete: ''
	    }, options );

	    var thisElement = $(this);

	    $({count: settings.start}).animate({count: settings.end}, {
			duration: settings.duration,
			easing: settings.easing,
			step: function() {
				var mathCount = Math.ceil(this.count);
				thisElement.text(mathCount);
			},
			complete: settings.complete
		});
	};

 $(window).scroll(function() {
              var extraInfoOffset = $('.product-form-main').offset().top;
              var scrollTop = $(window).scrollTop();

              // Adjust this value if needed to set when to toggle the class
              var triggerOffset = extraInfoOffset - 100;

              if (scrollTop > triggerOffset) {
                  $('.sticky-atc-qty').addClass('Sticky_Add-to-cart_button');
              } else {
                  $('.sticky-atc-qty').removeClass('Sticky_Add-to-cart_button');
              }
          });


$(document).ready(function() {
    // Function to update the cart count bubble
    function updateCartCount() {
        jQuery.getJSON('/cart.js', function(cart) {
            let cartData = cart.item_count;
            $(".cart-count-bubble span").text(cartData);
        });
    }

    // Handle the "Add to Cart" button click
    $(".product-form__buttons .product-form__submit").click(function(e) {
        e.preventDefault(); 
        let form = $(this).closest('form'); 
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            dataType: 'json',
            success: function() {
                updateCartCount();
                $("cart-drawer").removeClass("is-empty");
                $('#CartDrawer').load(location.href + " #CartDrawer>*", function() {
                    $("a#cart-icon-bubble span.visually-hidden").trigger("click");
                  console.log("JS is running");
                });
            }
        });
    });

    updateCartCount();
});



whenSlickReady(function ($) {
  $('.landing-new-slider ul').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1 
        }
      }
    ]
  });
});
whenSlickReady(function ($) {
  $('.pills-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1
  });
});

const faqLink = document.getElementById("faq-link");
if (faqLink) {
  faqLink.addEventListener("click", function (event) {
    event.preventDefault();

    const container = document.querySelector(".faq_tab");
    const detailsEl = container?.querySelector("details");
    const summaryEl = detailsEl?.querySelector("summary");

    if (container && detailsEl && summaryEl) {
      if (!detailsEl.open) detailsEl.setAttribute("open", "true");
      summaryEl.setAttribute("aria-expanded", "true");

      setTimeout(() => {
        const offset = 100;
        const top = container.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }, 200);
    }
  });
}

const installLink = document.getElementById("install-link");
if (installLink) {
  installLink.addEventListener("click", function (event) {
    event.preventDefault();

    const container = document.querySelector(".install_video");
    const detailsEl = container?.querySelector("details");
    const summaryEl = detailsEl?.querySelector("summary");

    if (container && detailsEl && summaryEl) {
      if (!detailsEl.open) detailsEl.setAttribute("open", "true");
      summaryEl.setAttribute("aria-expanded", "true");

      setTimeout(() => {
        const offset = 100;
        const top = container.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }, 200);
    }
  });
}

const howWorksLink = document.getElementById("how_works");
if (howWorksLink) {
  howWorksLink.addEventListener("click", function (event) {
    event.preventDefault();

    const container = document.querySelector(".how_works_tab");
    const detailsEl = container?.querySelector("details");
    const summaryEl = detailsEl?.querySelector("summary");

    if (container && detailsEl && summaryEl) {
      if (!detailsEl.open) detailsEl.setAttribute("open", "true");
      summaryEl.setAttribute("aria-expanded", "true");

      setTimeout(() => {
        const offset = 100;
        const top = container.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }, 200);
    }
  });
}




setInterval(function () {
  const element = document.querySelector('#app-embed');
  if (element && element.shadowRoot) {
    const shadowRoot = element.shadowRoot;
    const style = document.createElement('style');
    style.textContent = `
      ._radioFieldSet_nw6va_1{
        margin: 20px 0px;
      }
      div._dateFieldContainer_rzr7e_5{
        padding-bottom: 10px;
      }
      legend._textBody_2aowh_10._radioLegend_nw6va_18,._birthdayText_rzr7e_15{
        font-weight:bold !important;
      }
    `;
    shadowRoot.appendChild(style);
  }
}, 1000);